import { createFileRoute } from "@tanstack/react-router";
import { ShiftTemplatesFeature } from "@/features/shift-templates";

function ShiftTemplatesPage() {
  return <ShiftTemplatesFeature />;
}

export const Route = createFileRoute("/scheduler/templates/")({
  component: ShiftTemplatesPage,
  staticData: { authorize: true },
});
